import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { ProviderLogo } from '../../products/products/common/provider_logo';
import { withQuoteFlatten } from '../../products/products/common/with_quote_flatten';

const useStyles = createUseStyles((theme) => ({
    providerLogo: {
        width: '6.5rem',
        height: '3.9rem',
        alignSelf: 'center',
        marginBottom: theme.spacing[8]
    }
}));

const _ProductProviderLogo = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    const { providerCode } = props;

    return (
        <ProviderLogo className={classes.providerLogo} code={providerCode} containerSize="65x39"  />
    );
};

_ProductProviderLogo.propTypes = {
    quote: PropTypes.object.isRequired,

    providerCode: PropTypes.string
};

const ProductProviderLogo = withQuoteFlatten(_ProductProviderLogo);

export { ProductProviderLogo };
